import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import {
  Description,
  SubTitle,
} from "../../Components";
import ThemeSpinner from "../../Components/general/ThemeSpinner";
import ThemeInput from "../../Components/input/ThemeInput";
import { errorMsg, successMsg } from "../../constants/msgs";
import { useNavigate } from "react-router-dom";
import { logout } from "../../store/services/authInfo";
import { EmptyLocalStorage } from "../../utils/helper";
import { useGetStaticPageQuery, useSavePageMutation } from "../../store/apis/settingsApi";
import { COINS_CONVERSION_TYPE } from "../../constants/constant";

export default function CoinConversion() {
  const {
    handleSubmit: handleUsdSubmit,
    control: usdControl,
    setValue: setUsdValue,
    formState: { errors: usdErrors },
  } = useForm({
    defaultValues: {
      usd_conversion: "",
    },
  });

  const {
    handleSubmit: handleBtcSubmit,
    control: btcControl,
    setValue: setBtcValue,
    formState: { errors: btcErrors },
  } = useForm({
    defaultValues: {
      btc_conversion: "",
    },
  });

  const navigate = useNavigate();

  // Fetch USD Conversion Rate
  const { data: usdData, isSuccess: isUsdSuccess } = useGetStaticPageQuery({
    type: COINS_CONVERSION_TYPE.COINS_USD_CONVERSION
  });

  // Fetch BTC/Crypto Conversion Rate
  const { data: btcData, isSuccess: isBtcSuccess } = useGetStaticPageQuery({
    type: COINS_CONVERSION_TYPE.COINS_CRYPTO_CONVERSION
  });

  // console.log(usdData.data);
  // console.log(btcData.data);

  useEffect(() => {
    if (isUsdSuccess && usdData?.data) {
      setUsdValue("usd_conversion", usdData.data.text);
    }
  }, [usdData, isUsdSuccess, setUsdValue]);

  useEffect(() => {
    if (isBtcSuccess && btcData?.data) {
      setBtcValue("btc_conversion", btcData.data.text);
    }
  }, [btcData, isBtcSuccess, setBtcValue]);

  const [savePage, { isLoading }] = useSavePageMutation();
  const [activeSubmission, setActiveSubmission] = useState(null);

  const handleDataSubmission = async (userData, type) => {
    try {
      setActiveSubmission(type);
      const payload = {
        type: type,
        text: userData.usd_conversion || userData.btc_conversion
      };

      const response = await savePage({ data: payload, type }).unwrap();

      if (response.status === 400) {
        errorMsg(response?.data?.errors, "error");
      } else {
        successMsg(response?.message, "success");
      }
    } catch (error) {
      errorMsg(error?.data?.message, "error");
    } finally {
      setActiveSubmission(null);
    }
  };

  return (
    <div className={"ChangePassword"}>
      <SubTitle text="Coin Conversion" classes="text-white" />
      <Description
        text="Enter the conversion rate for the coin."
        classes="fs-8 mb-4 text-white"
      />
      <Form onSubmit={handleUsdSubmit((data) => handleDataSubmission(data, COINS_CONVERSION_TYPE.COINS_USD_CONVERSION))}>
        <div className={"form"}>
          <div className="">
            <ThemeInput

              name="usd_conversion"
              control={usdControl}
              errors={usdErrors}
              rules={{
                required: {
                  value: true,
                  message: "USD Conversion Rate is required.",
                },
              }}
              label="USD Conversion Rate"
              placeholder="Enter USD Conversion Rate"
              type={"number"}
            />
          </div>
          <div className={"d-flex justify-content-end w-100"}>
            <Button
              type="submit"
              disabled={isLoading && activeSubmission === COINS_CONVERSION_TYPE.COINS_USD_CONVERSION}
              className="btn-solid btn-red w-50 mt-4"
              text="Save"
            >
              {isLoading && activeSubmission === COINS_CONVERSION_TYPE.COINS_USD_CONVERSION ? <ThemeSpinner /> : "Save"}
            </Button>
          </div>
        </div>
      </Form>

      <hr></hr>

      <Form onSubmit={handleBtcSubmit((data) => handleDataSubmission(data, COINS_CONVERSION_TYPE.COINS_CRYPTO_CONVERSION))}>
        <div className={"form"}>
          <div className="">
            <ThemeInput
              name="btc_conversion"
              control={btcControl}
              errors={btcErrors}
              rules={{
                required: {
                  value: true,
                  message: "BTC Conversion Rate is required.",
                },
              }}
              label="BTC Conversion Rate"
              placeholder="Enter BTC Conversion Rate"
              type={"number"}
            />
          </div>
          <div className={"d-flex justify-content-end w-100"}>
            <Button
              type="submit"
              disabled={isLoading && activeSubmission === COINS_CONVERSION_TYPE.COINS_CRYPTO_CONVERSION}
              className="btn-solid btn-red w-50 mt-4"
              text="Save"
            >
              {isLoading && activeSubmission === COINS_CONVERSION_TYPE.COINS_CRYPTO_CONVERSION ? <ThemeSpinner /> : "Save"}
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
}
